import React, { useState } from "react"

import { Grid, TextField, FormHelperText } from '@mui/material';
import SelectForm from "../Select";
import DatePicker from "../DatePicker";






export default function Form({ field, handleChangeMain, error, dependencyFilter, valueField }) {

    if (Object.keys(field)?.length === 0) return true
    let data = [...field?.principales, ...field?.atributos]

    const handleChange = (value, fields) => {
        handleChangeMain(value, fields)
    }

    if (!valueField[data[0].id]) data = [data[0]]

    return (
        <Grid className={"marginTop styleInputs inputMain"} container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            {data?.map((itemData, key) => {
                if (itemData.tipo === "tabla" || itemData.tipo === "lista" || itemData.tipo === "listaSinComentarios") {

                    return (
                        <Grid item md={6} sm={6} xs={12} key={key}>
                            <SelectForm 
                            data={itemData}
                            handleChange={handleChange}
                            dependencyFilter={dependencyFilter} 
                            valueField={valueField}
                            />
                            <FormHelperText className={"errorMenssage"}>{error[itemData.id]}</FormHelperText>
                        </Grid>
                    )
                } else if (itemData.tipo === "texto" || itemData.tipo === "textoLargo") {
                    let valueText = valueField[itemData.id]
                    if(!valueText)  valueText =  ""
                    let numberRow = itemData.tipo === "textoLargo"  ? 3 : 1 
                    return (
                        <Grid item md={6} sm={6} xs={12} key={key} >

                            <TextField
                                required={itemData?.obligatorio}
                                label={itemData.item}
                                variant="outlined"
                                multiline
                                rows={numberRow}
                                fullWidth={true}
                                value={valueField[itemData.id]}
                                inputProps={{ maxLength: itemData.longitud }}
                                onChange={e => handleChange(e.target.value, itemData.id)}
                            />
                            <FormHelperText className={"errorMenssage"}>{error[itemData.id]}</FormHelperText>

                        </Grid>
                    )
                } else if (itemData.tipo === "fecha") {
                    return (
                        <Grid item md={6} sm={6} xs={12} key={key} >
                            <DatePicker handleChange={handleChange} data={itemData} valueField={valueField} />
                            <FormHelperText className={"errorMenssage"}>{error[itemData.id]}</FormHelperText>
                        </Grid>
                    )
                }

            })}


        </Grid>
    )
}